import { FC, ReactNode } from "react";

import { CrossIcon } from "../../../assets/img/icons";
import Text from "../../Text";

import styles from "./styles.module.scss";

type Props = {
    title: string;
    handleClose: () => void;
    /** Sous-texte affiché sous le titre */
    subtitle?: string;
    /** Petit libellé affiché à droite du titre */
    titleRightLabel?: string;
    /** Icône affichée à gauche du titre (ex: 🏆) */
    icon?: ReactNode;
};

const ModalHeader: FC<Props> = ({
    title,
    handleClose,
    subtitle,
    titleRightLabel,
    icon,
}) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                {icon && <span className={styles.icon}>{icon}</span>}
                <div>
                    <div className={styles.titleRow}>
                        <Text variant="title">{title}</Text>
                        {titleRightLabel && (
                            <span className={styles.titleRightLabel}>
                                {titleRightLabel}
                            </span>
                        )}
                    </div>
                    {subtitle && (
                        <p className={styles.subtitle}>{subtitle}</p>
                    )}
                </div>
            </div>
            <CrossIcon className={styles.close} onClick={handleClose} />
        </div>
    );
};

export default ModalHeader;
